var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.aktiviteter),function(aktivitet){return _c('aktiviteterBtn',{key:aktivitet,attrs:{"title":aktivitet.title,"text":aktivitet.text,"bildetittel":aktivitet.bilde}})}),_c('div',{staticStyle:{"paddingBottom":"10%"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }